"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeModuleValidation = void 0;
var react_1 = __importDefault(require("react"));
var debug_1 = __importDefault(require("debug"));
var utils_1 = require("../utils");
var extendHOC_1 = __importDefault(require("./extendHOC"));
function makeModuleValidation(moduleLocator) {
    return function withModuleValidation(moduleName) {
        return function (WrappedComponent) {
            var name = utils_1.getDisplayName(WrappedComponent);
            var debug = debug_1.default("app:validateModule:" + name);
            var ModuleValidator = /** @class */ (function (_super) {
                __extends(ModuleValidator, _super);
                function ModuleValidator() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.state = {
                        module: null,
                    };
                    return _this;
                }
                ModuleValidator.prototype.componentDidMount = function () {
                    var _this = this;
                    moduleLocator.get(moduleName).subscribe(function (module) {
                        _this.setState({
                            module: module,
                        });
                    });
                };
                ModuleValidator.prototype.render = function () {
                    var _a;
                    var module = this.state.module;
                    if (!module) {
                        debug('render %o', this.props, this.state);
                        return null;
                    }
                    return react_1.default.createElement(WrappedComponent, __assign(__assign({}, this.props), (_a = {}, _a[moduleName] = module, _a)));
                };
                return ModuleValidator;
            }(react_1.default.Component));
            return extendHOC_1.default(WrappedComponent, ModuleValidator);
        };
    };
}
exports.makeModuleValidation = makeModuleValidation;
//# sourceMappingURL=withModuleValidation.js.map